import { createDefaultTyrann } from '@apis/common';
import { warehouse, warehouseBase, warehouseQuery } from '@models/Warehouse';
import * as t from 'io-ts';

export const warehouseApis = createDefaultTyrann({
  '/dashboard/warehouse/': {
    get: {
      query: warehouseQuery,
      response: {
        200: t.array(warehouse),
      },
    },
    post: {
      body: warehouseBase,
      response: {
        201: warehouse,
      },
    },
  },
  '/dashboard/warehouse/{id}/': {
    get: {
      path: t.type({ id: t.number }),
      response: {
        200: warehouse,
      },
    },
    put: {
      path: t.type({ id: t.number }),
      body: warehouseBase,
      response: {
        200: warehouse,
        500: t.type({}),
      },
    },
  },
});
